import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteNutritionalCounsellingMutation as useChDeleteNutritionalCounsellingMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChDeleteNutritionalCounsellingMutation.graphql"

const mutation = graphql`
  mutation useChDeleteNutritionalCounsellingMutation($input: Ch_deleteNutritionalPrescriptionInput!) {
    ch_deleteNutritionalPrescription(input: $input) {
      ch_NutritionalPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteNutritionalCounsellingMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteNutritionalCounsellingMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteNutritionalCounsellingMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteNutritionalCounsellingMutation }
